module.exports = __webpack_public_path__ + "static/media/restaurant-pos.be407ef6.jpg";